const SEEN_LECTURES_KEY = 'aimie_seen_lecture_ids_v1';
const LECTURE_STATE_EVENT = 'aimie:lecture-viewing-state-changed';

function readSeenLectures() {
  try {
    const stored = JSON.parse(window.localStorage.getItem(SEEN_LECTURES_KEY) || '[]');
    return new Set(Array.isArray(stored) ? stored.filter((value) => typeof value === 'string') : []);
  } catch {
    return new Set();
  }
}

function notifyLectureStateChanged() {
  window.dispatchEvent(new CustomEvent(LECTURE_STATE_EVENT));
}

export function hasSeenLecture(lectureId) {
  return readSeenLectures().has(lectureId);
}

export function markLectureSeen(lectureId) {
  if (!lectureId) return;
  try {
    const seen = readSeenLectures();
    seen.add(lectureId);
    window.localStorage.setItem(SEEN_LECTURES_KEY, JSON.stringify([...seen]));
  } catch {
    // Browser privacy settings may make localStorage unavailable.
  }
  notifyLectureStateChanged();
}

export function subscribeToLectureViewingState(listener) {
  const handleStorage = (event) => {
    if (event.key === SEEN_LECTURES_KEY) {
      listener();
    }
  };
  window.addEventListener(LECTURE_STATE_EVENT, listener);
  window.addEventListener('storage', handleStorage);
  return () => {
    window.removeEventListener(LECTURE_STATE_EVENT, listener);
    window.removeEventListener('storage', handleStorage);
  };
}

export { SEEN_LECTURES_KEY };
